module.exports = __webpack_public_path__ + "calendar.svg?b6689d7ef8c5da6134c9a8d6da991e26";